module.exports = __webpack_public_path__ + "static/media/Red.4a98ec3e.mp4";